import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
  Form,
  Input,
} from '@tencent/tea-component';

const CreateGroupModal = (props) => {
  const [groupName, setGroupName] = useState('');

  return <>
      <Modal
        size="s"
        caption={ props.caption }
        visible={ props.visable }
        onClose={() => {
          props.onClose();
        }}
      >
    <Modal.Body>
        <Form>
            <Form.Item label="组名">
              <Input placeholder="输入用户组名"
                value={groupName}
                onChange={(value) => {
                  setGroupName(value);
                }}
                />
            </Form.Item>
        </Form>
    </Modal.Body>
    <Modal.Footer>
        <Button type="primary" onClick={() => {
          props.onClick(groupName);
          setGroupName('');
        }}>
            { props.okText }
        </Button>
        <Button type="weak" onClick={() => {
          props.onClose();
        }}>
            { props.cancelText }
        </Button>
    </Modal.Footer>
  </Modal>
    </>;
};

CreateGroupModal.propTypes = {
  caption: PropTypes.string,
  visable: PropTypes.bool,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
};

export default CreateGroupModal;
